var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "70",
      "height": "69"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-width": "3"
    }
  }, [_c('path', {
    attrs: {
      "stroke": "#FFE86C",
      "d": "M35 66.916c-8.985 0-17.119-3.642-23.006-9.53-5.888-5.89-9.53-14.025-9.53-23.011s3.642-17.121 9.53-23.01C17.88 5.476 26.015 1.834 35 1.834s17.119 3.642 23.006 9.53c5.888 5.89 9.53 14.025 9.53 23.011s-3.642 17.121-9.53 23.01C52.12 63.274 43.985 66.916 35 66.916Z"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#005149",
      "stroke-linecap": "round",
      "d": "M26.072 25.524 43.928 43.38m0-18.005L26.072 43.231"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }